/**
 * Create the apply filter tracking object
 * @param {object} trackingData - Tracking Data
 */

import { IOfferKeyElements, retrieveFromOfferId } from 'Container/Landingpage/helpers/offerDataHelper';
import {TRACKING_ADD_FILTER_ACTION} from 'Container/Tracking/constant';

/**
 * Creates Tracking Parameter for "user has"
 * @param offerKeyElements
 */
const getOwnAsTrackingString = (offerKeyElements) => {
    const own: string[] = [];
    if (true === offerKeyElements.has_mobilfunk) {
        own.push('mobile');
    }
    if (true === offerKeyElements.has_internet) {
        own.push('internet');
    }
    if (true === offerKeyElements.has_tv) {
        own.push('tv');
    }
    if (true === offerKeyElements.has_none) {
        own.push('nothing yet');
    }

    return own.toString();
};

/**
 * Creates Tracking Parameter for "user wants"
 * @param offerKeyElements
 */
const getWantsAsTrackingString = (offerKeyElements) => {
    const own: string[] = [];
    if (true === offerKeyElements.wants_mobilfunk) {
        own.push('mobile');
    }
    if (true === offerKeyElements.wants_internet) {
        own.push('internet');
    }
    if (true === offerKeyElements.wants_tv) {
        own.push('tv');
    }
    if (true === offerKeyElements.wants_redplus) {
        own.push('partner card');
    }

    return own.toString();
};

/**
 * Create the Apply Filter Tracking Object
 * @param {object} trackingData - Tracking Data
 */
export const createTrackingApplyFilter = (offerId) => {
    const offerKeyElements: IOfferKeyElements = retrieveFromOfferId(offerId);
    const trackingPayload = {
        action: TRACKING_ADD_FILTER_ACTION,
        appliedFilters: [
            {
                facet: 'own',
                value: getOwnAsTrackingString(offerKeyElements),
            },
            {
                facet: 'wish',
                value: getWantsAsTrackingString(offerKeyElements),
            },
        ],
    };

    return trackingPayload;
};
